
import { useNavigate, useParams } from "react-router-dom";
import { useQuery, gql, useMutation } from '@apollo/client';
import {
  Dropdown,
  Divider,
  Header,
} from 'semantic-ui-react'

import { InterimStates } from "../../../components/InterimStates";
import { useIsAdmin } from '../../../hooks/isAdmin';

const GET_POSSIBLE_STUDENTS = gql`
    query OrganisationMembers {
        organisationMembers {
            id
            identifier
            name
        }
    }
`;

const UPDATE_COURSE_PARTICIPANTS = gql`
    mutation UpdateParticipantList($courseId: Int!, $participantIds: [Int!]!) {
        updateParticipantList(courseId: $courseId, participantIds: $participantIds) {
            status
        }
    }
`;

const CourseAdmin = ({ participants, refetchCourse }: { participants: any, refetchCourse: any }) => {
    let { id: courseId } = useParams();
    const isAdmin = useIsAdmin();
    let navigate = useNavigate();

    // mutation to update course participants
    const [updateCourseParticipants] = useMutation(UPDATE_COURSE_PARTICIPANTS);

    // GET possible students
    const { loading: loadingPossible, error: errorPossible, data: dataPossible } = useQuery(GET_POSSIBLE_STUDENTS);

    // Any error or loading
    if (loadingPossible || errorPossible) {
        return <InterimStates loading={loadingPossible} error={errorPossible} label='persons details' />
    }

    if (!isAdmin) {
        return null;
    }

    const handleChange = async (_: any, data: any) => {
        // call mutation to update value
        await updateCourseParticipants({
            variables: {
                courseId: Number(courseId),
                participantIds: data.value
            }
        });

        refetchCourse();

        if (participants.length > data.value.length) {
            navigate(`/classes/${courseId}/records`);
        }
    };

    // copy the data
    let peopleOptions = dataPossible.organisationMembers.map((p: any) => {
        return {
            id: p.id,
            identifier: p.identifier,
            name: p.name,
        }
    });

    // sort by identifier
    peopleOptions = peopleOptions.sort((a: any, b: any) => {
        if (a.identifier < b.identifier) {
            return -1;
        }
        if (a.identifier > b.identifier) {
            return 1;
        }
        return 0;
    });

    peopleOptions = peopleOptions.map((p: any) => ({
        key: p.id,
        text: `${p.name} (${p.identifier})`,
        value: p.id,
    }));

    return (
        <>
            <Divider horizontal>
                <Header as='h4'>
                Admin
                </Header>
            </Divider>
            <Dropdown
                placeholder='Students'
                fluid
                multiple
                value={participants.map((p: any) => p.id)}
                onChange={handleChange}
                search
                selection
                options={peopleOptions}
            />
        </>
    )
}

export { CourseAdmin }
